import React from 'react';
import { mdiClose, mdiMenu } from '@mdi/js';
import { Button, HeaderLogo, IconButton } from '@upgrade/react-components';
import { joinPaths } from '@upgrade/ui-utils/utils/url';
import MenuItem from './menu-item';
import LocaleSwitcherMenuItem from '../LocaleSwitcher/LocaleSwitcherMenuItem';
import HeaderContainer, { CanadaNavItemsContainer, MenuWrapper, MobileHeader, StyledMobileSignInBtn } from './styles';
import Fluid from '../../Fluid';
import { HEADER_ID } from '../../../constants/ids-constants';

import { useLocale } from '../../../utils/locale';
import { FLEX_PAY, UPLIFT_HOME, UPLIFT_LOGIN } from '../../../constants/path-constants';
import { scrollToHowItWorksSection } from '../../flex-pay/product';
import Link from '../Link';

const CanadaHeaderMenu = ({
  handleMenuClick,
  visibleSubMenuId,
  showMobileMenu,
  showNavigation,
  showNavItems,
  isNotFoundPage,
  openMenuButtonRef,
  setShowMobileMenu,
  navContainerRef,
  handleCloseMenu,
  menuIconProps,
  addHeaderShadow
}) => {
  const { locale, trackWithLocale } = useLocale();
  const { pathname: localePath } = locale || {};
  const logoHref = joinPaths(UPLIFT_HOME, localePath, '/homepage/');

  const handleSignInClicked = () => {
    trackWithLocale({ event: 'sign_in_clicked' });
    window.open(UPLIFT_LOGIN);
  };

  return (
    <HeaderContainer id={HEADER_ID} className="desktop-header" addHeaderShadow={addHeaderShadow}>
      <Fluid>
        {showNavigation && showNavItems !== false && !isNotFoundPage && (
          <IconButton
            {...{ ...menuIconProps }}
            className="hidden-md"
            ref={openMenuButtonRef}
            icon={mdiMenu}
            iconProps={{ title: 'open navigation' }}
            color="actionablePrimary"
            onClick={() => setShowMobileMenu(true)}
            onKeyDown={handleMenuClick('')}
          />
        )}
        <HeaderLogo {...{ Link, href: logoHref, logoMobileLarge: true }} />

        <MenuWrapper visible={showMobileMenu} justifyContent="start">
          <MobileHeader>
            <IconButton
              {...{ ...menuIconProps }}
              icon={mdiClose}
              iconProps={{ title: 'close navigation' }}
              color="content"
              onClick={handleCloseMenu}
              onKeyDown={handleMenuClick('')}
            />
            <div>
              <HeaderLogo {...{ Link, href: logoHref, logoMobileLarge: true }} />
            </div>
          </MobileHeader>

          <nav>
            <CanadaNavItemsContainer ref={navContainerRef}>
              <MenuItem
                label="How Flex Pay Works"
                to={joinPaths(localePath, FLEX_PAY)}
                onClick={scrollToHowItWorksSection}
              />
              <MenuItem label="Our Partners" to={joinPaths(UPLIFT_HOME, localePath, '/partners')} />
              <MenuItem label="Become a Partner" to={joinPaths(UPLIFT_HOME, localePath, '/find-partners')} />
              <MenuItem label="Help" to={joinPaths(UPLIFT_HOME, localePath, '/help')} />
              <LocaleSwitcherMenuItem {...{ handleMenuClick, visibleSubMenuId }} />
            </CanadaNavItemsContainer>
          </nav>

          {showNavigation && (
            <StyledMobileSignInBtn
              data-auto="mobile-sign-in"
              className="hidden-md"
              emphasis="secondary"
              onClick={handleSignInClicked}
            >
              Sign In
            </StyledMobileSignInBtn>
          )}
        </MenuWrapper>

        <Button data-auto="desktop-sign-in" emphasis="secondary" button onClick={handleSignInClicked}>
          Sign In
        </Button>
      </Fluid>
    </HeaderContainer>
  );
};

export default CanadaHeaderMenu;
